import React from 'react';
import { DataExplorerMetricCards } from './DataExplorerMetricCards';
import { DataExplorerDimensionBarChart } from './DataExplorerDimensionBarChart';
import { DataExplorerPieChart } from './DataExplorerPieChart';

/**
 * Wrapper que agrupa los nuevos gráficos del Data Explorer (debajo de la tabla).
 * Solo se renderiza cuando hay datos.
 *
 * Props:
 *  - results: { tableData, ... }
 *  - lastFilters: { dimensions, metrics, compare, ... }
 *  - fieldsData: { FIELD_DATA_BY_ID, ... }
 */
export function DataExplorerChartsSection({ results, lastFilters, fieldsData }) {
    const hasData = results && results.tableData && results.tableData.rows && results.tableData.rows.length > 0;
    if (!hasData || !lastFilters) return null;

    return (
        <div className="de-charts-section">
            {/* 1. Métricas clave */}
            <DataExplorerMetricCards
                results={results}
                lastFilters={lastFilters}
                fieldsData={fieldsData}
            />
            {/* 2. Gráfico de barras (8 cols) + torta (4 cols) en una misma fila */}
            <div className="row de-charts-row">
                <div className="col-8">
                    <DataExplorerDimensionBarChart
                        results={results}
                        lastFilters={lastFilters}
                        fieldsData={fieldsData}
                    />
                </div>
                <div className="col-4">
                    <DataExplorerPieChart
                        results={results}
                        lastFilters={lastFilters}
                        fieldsData={fieldsData}
                    />
                </div>
            </div>
        </div>
    );
}
